"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportClient = void 0;
const BaseClient_1 = require("../BaseClient");
class ExportClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async post(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/export/post',
            data: request,
        });
        return response.data;
    }
    async get(id) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/export/get',
            params: {
                id,
            },
        });
        return response.data;
    }
    async list(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/export/list',
            data: request,
        });
        return response.data;
    }
    /**
     * Gets result as binary data
     * NOTE this call puts file data into memory, use this call if you need to get result when authenticated with JWT
     * otherwise use getResultUrl method
     *
     * @param exportId
     */
    async getResult(exportId) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/export/result',
            params: {
                exportId,
            },
            responseType: 'arraybuffer',
        });
        return {
            data: response.data,
            contentType: response.headers['content-type'],
        };
    }
    getResultUrl(exportId, downloadFileName) {
        let url = `${this.axiosInstance.defaults.baseURL}/api/v1/export/result?exportId=${exportId}`;
        if (downloadFileName) {
            url += `&downloadFileName=${downloadFileName}`;
        }
        return url;
    }
}
exports.ExportClient = ExportClient;
